import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { requestOTP, ValidateOTP, GetPriceRule, RegisterSchool, RegisterPayment, ValidateEmail } from './module';

const initialState = {
    mySession: null,
    OTPKey: null,
    countdownNo: 60,
    schoolFormData: JSON.parse(sessionStorage.getItem('sfs')),
    isRequestedOtp: false,
    priceRules: null,
    disableBtn: false,
    status: "idle",
    ActionStatus: "",
    errorMessage: ""
};

export const ValidateEmailAsync = createAsyncThunk(
    'schoolSummary/requestOTP',
    async (data, ThunkAPI) => {
        const response = await ValidateEmail(data);
        return response;
    }
);

export const GetPriceRuleAsync = createAsyncThunk(
    'schoolSummary/GetPriceRule',
    async (data, ThunkAPI) => {
        const response = await GetPriceRule();
        return response;
    }
);

export const resendOTPAsync = createAsyncThunk(
    'schoolSummary/resendOTP',
    async (data, ThunkAPI) => {
        const response = await requestOTP(data);
        return response;
    }
);

export const RegisterSchoolAsync = createAsyncThunk(
    'schoolSummary/RegisterSchool',
    async (data, ThunkAPI) => {
        const response = await RegisterSchool(data);
        return response;
    }
);

export const RegisterPaymentAsync = createAsyncThunk(
    'schoolSummary/RegisterPayment',
    async (data, ThunkAPI) => {
        const response = await RegisterPayment(data);
        return response;
    }
);

export const ValidateOTPAsync = createAsyncThunk(
    'schoolSummary/validateOTP',
    async (json, ThunkAPI) => {
        const response = await ValidateOTP(json);
        const resultPromise = Promise.resolve(response);
        resultPromise.then((r, index) => {
            if (r && r.Status === 'OK') {
                ThunkAPI.dispatch(RegisterSchoolAsync(JSON.parse(sessionStorage.getItem('sfs'))));
            } else {
                alert('Failed to validate OTP');
            }

        })
        return response;
    }
);

export const schoolSummarySlice = createSlice({
    name: 'schoolSummary',
    initialState,
    reducers: {
        clearAction: (state, action) => {
            state.isRequestedOtp = null;
        },
        ChangeCountdownNumber: (state, action) => {
            state.countdownNo = action.payload;
        },
        triggerDisableBtn: (state, action) => {
            state.disableBtn = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(ValidateEmailAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(ValidateEmailAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(ValidateEmailAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.isRequestedOtp = true;
                state.OTPKey = action.payload.OTPKey
            }
        });
        builder.addCase(resendOTPAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(resendOTPAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(resendOTPAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.OTPKey = action.payload.OTPKey
            }
        });
        builder.addCase(ValidateOTPAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(ValidateOTPAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(ValidateOTPAsync.fulfilled, (state, action) => {
            state.status = 'idle';
        });
        builder.addCase(GetPriceRuleAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetPriceRuleAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetPriceRuleAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                state.priceRules = action.payload.PriceRules
            }
        });
        builder.addCase(RegisterSchoolAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(RegisterSchoolAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(RegisterSchoolAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage);
            } else {
                var orderCode = action.payload && action.payload.Orders ? action.payload.Orders[0].OrderCode : '';
                sessionStorage.removeItem('sfs');
                //window.wogaaCustom.startTransactionalService('ArchivesOnline-2859');
                window.wogaaCustom.completeTransactionalService('ArchivesOnline-2859');
                setTimeout(() => {
                    window.location.href = "./order/success?order_code="+orderCode;
                }, 500);
            }
        });
        builder.addCase(RegisterPaymentAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(RegisterPaymentAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(RegisterPaymentAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }
            // else{
            //     sessionStorage.removeItem('mfs');
            //     var payment = action.payload.data;
            //     var form = document.createElement("form");
            //     var paymentElement = document.createElement("input");

            //     form.method = "POST";
            //     form.action = payment.Url;

            //     paymentElement.value = payment.PaymentXml;
            //     paymentElement.type = "hidden";
            //     paymentElement.name = "PAYMENT";

            //     form.appendChild(paymentElement);

            //     document.body.appendChild(form);

            //     form.submit();
            // }

        });
    }
});

export const { clearAction, triggerDisableBtn, ChangeCountdownNumber } = schoolSummarySlice.actions;
export const pagesState = (state) => state.schoolSummary;
export const formData = (state) => state.schoolSummary.schoolFormData;
export const mySession = (state) => state.Session.mySession;
export const myLibs = (state) => state.Session.myLibs;

export const checkOutCurCart = (data) => (dispatch, getState) => {
    dispatch(RegisterSchoolAsync(JSON.parse(sessionStorage.getItem('sfs'))));
};

export default schoolSummarySlice.reducer;
